/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type IntroductionMessageContentInput = {
  /** oneof */
  plainIntroductionMessage?: PlainIntroductionMessageInput | null | undefined;
  scenarioChatIntroductionMessage?: ScenarioChatIntroductionMessageInput | null | undefined;
};

export type PlainIntroductionMessageInput = {
  body: string;
  /** 初期チャットメッセージは選択肢なしもあるので、選択肢を消したい・入れたくないときはselectionsに空配列を入れる */
  selections: Array<string>;
};

export type SaveDefaultIntroductionMessageInput = {
  content: IntroductionMessageContentInput;
};

export type ScenarioChatIntroductionMessageInput = {
  scenarioChatGuid: string | number;
};

export type FetchSettingsPageIntroductionMessageViewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSettingsPageIntroductionMessageViewQuery = { viewer: { hasLineActivationProvider: boolean }, introductionMessageSetting: { default: { content:
        | { __typename: 'PlainIntroductionMessageContent', body: string, selections: Array<string> }
        | { __typename: 'ScenarioChatIntroductionMessageContent', scenarioChatGuid: string }
       } | null, conditional: Array<{ guid: string, content:
        | { __typename: 'PlainIntroductionMessageContent', body: string, selections: Array<string> }
        | { __typename: 'ScenarioChatIntroductionMessageContent', scenarioChatGuid: string }
      , condition: { userRegistrationInflowSourceDefinition: { guid: string, inflowSourceName: string } } }> } };

export type SaveDefaultIntroductionMessageMutationVariables = Exact<{
  input: Types.SaveDefaultIntroductionMessageInput;
}>;


export type SaveDefaultIntroductionMessageMutation = { saveDefaultIntroductionMessage: { setting: { default: { content:
          | { __typename: 'PlainIntroductionMessageContent', body: string, selections: Array<string> }
          | { __typename: 'ScenarioChatIntroductionMessageContent', scenarioChatGuid: string }
         } | null } } };


export const FetchSettingsPageIntroductionMessageViewDocument = gql`
    query FetchSettingsPageIntroductionMessageView {
  viewer {
    hasLineActivationProvider
  }
  introductionMessageSetting {
    default {
      content {
        __typename
        ... on PlainIntroductionMessageContent {
          body
          selections
        }
        ... on ScenarioChatIntroductionMessageContent {
          scenarioChatGuid
        }
      }
    }
    conditional {
      guid
      content {
        __typename
        ... on PlainIntroductionMessageContent {
          body
          selections
        }
        ... on ScenarioChatIntroductionMessageContent {
          scenarioChatGuid
        }
      }
      condition {
        userRegistrationInflowSourceDefinition {
          guid
          inflowSourceName
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSettingsPageIntroductionMessageViewQuery__
 *
 * To run a query within a Vue component, call `useFetchSettingsPageIntroductionMessageViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSettingsPageIntroductionMessageViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchSettingsPageIntroductionMessageViewQuery();
 */
export function useFetchSettingsPageIntroductionMessageViewQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>(FetchSettingsPageIntroductionMessageViewDocument, {}, options);
}
export function useFetchSettingsPageIntroductionMessageViewLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>(FetchSettingsPageIntroductionMessageViewDocument, {}, options);
}
export type FetchSettingsPageIntroductionMessageViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchSettingsPageIntroductionMessageViewQuery, FetchSettingsPageIntroductionMessageViewQueryVariables>;
export const SaveDefaultIntroductionMessageDocument = gql`
    mutation saveDefaultIntroductionMessage($input: SaveDefaultIntroductionMessageInput!) {
  saveDefaultIntroductionMessage(input: $input) {
    ... on SaveIntroductionMessageSuccess {
      setting {
        default {
          content {
            __typename
            ... on PlainIntroductionMessageContent {
              body
              selections
            }
            ... on ScenarioChatIntroductionMessageContent {
              scenarioChatGuid
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSaveDefaultIntroductionMessageMutation__
 *
 * To run a mutation, you first call `useSaveDefaultIntroductionMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveDefaultIntroductionMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveDefaultIntroductionMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveDefaultIntroductionMessageMutation(options: VueApolloComposable.UseMutationOptions<SaveDefaultIntroductionMessageMutation, SaveDefaultIntroductionMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveDefaultIntroductionMessageMutation, SaveDefaultIntroductionMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveDefaultIntroductionMessageMutation, SaveDefaultIntroductionMessageMutationVariables>(SaveDefaultIntroductionMessageDocument, options);
}
export type SaveDefaultIntroductionMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveDefaultIntroductionMessageMutation, SaveDefaultIntroductionMessageMutationVariables>;